var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItSupport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 15.75V14.25H17.25V15.75H0.75ZM3 13.5C2.5875 13.5 2.23438 13.3531 1.94063 13.0594C1.64688 12.7656 1.5 12.4125 1.5 12V3.75C1.5 3.3375 1.64688 2.98438 1.94063 2.69063C2.23438 2.39687 2.5875 2.25 3 2.25H15C15.4125 2.25 15.7656 2.39687 16.0594 2.69063C16.3531 2.98438 16.5 3.3375 16.5 3.75V12C16.5 12.4125 16.3531 12.7656 16.0594 13.0594C15.7656 13.3531 15.4125 13.5 15 13.5H3ZM3 12H15V3.75H3V12Z",
    fill: "#310000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItSupport);
export default __webpack_public_path__ + "static/media/it-support.63bc8d07b2684fd38c542f71841b4db1.svg";
export { ForwardRef as ReactComponent };